<script setup lang="js">
import { computed } from 'vue';
import Multiselect from 'vue-multiselect';

const props = defineProps({
  inputArgument: {
    type: Object,
    required: true
  },
  allVariables: {
    type: Array,
    required: true
  }
});

const model = defineModel({ type: Object });

const columnVariables = computed(() =>
  props.allVariables.reduce(
    (acc, v) => (v.type !== 'array' ? acc : [...acc, ...v.table_columns]),
    []
  )
);

const availableVariables = computed(() => {
  const columns = columnVariables.value;
  const allVars = props.allVariables;
  const onlyColumn = props.inputArgument.onlyColumn;

  return (onlyColumn ? columns : allVars).filter((item) => item.type === props.inputArgument.type);
});
</script>

<template>
  <label class="form-label">
    <span>{{ props.inputArgument.title }} [{{ props.inputArgument.type }}] </span>
    <span v-if="props.inputArgument.required" style="color: red">*</span>
  </label>

  <Multiselect
    v-model="model"
    :options="availableVariables"
    placeholder="Выбрать..."
    :multiple="false"
    label="title"
    track-by="name"
    class="multiselect-style"
  />
</template>
